import React from "react";
import { withStyles } from "@material-ui/core/styles";
const styles = (theme) => ({
  header: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    marginTop: 24,
    marginBottom: 12,
    display: "block"
  },
  upperCase: {
    textTransform: "uppercase"
  }
});

const FormSectionHeader = ({ classes, label, uppercase }) => (
  <span className={`${classes.header} ${uppercase ? classes.upperCase : ""}`}>
    {label}
  </span>
);

export default withStyles(styles)(FormSectionHeader);
